import { useState } from 'react'
import { FaGithub } from 'react-icons/fa'
import { MdClose } from 'react-icons/md'
import { SecondaryButton, TransparentButton } from 'common/button'
import { Typography } from 'components/common/typography'
import ConfirmationModal from 'common/confirmation-modal'
import { useUnlinkGithub } from 'mutations/profile'
import SocialMediaVinculationStyled from './social-media-vinculation'
import Notification from './notification'

const GH_CLIENT_ID = process.env.GH_CLIENT_ID || 'radnom'
const NEXTAUTH_URL = process.env.NEXTAUTH_URL

function GitHubButton({ username, token }) {
  const [remove, setRemove] = useState(false)
  const { mutate, isSuccess, isError } = useUnlinkGithub()

  const url = `https://github.com/login/oauth/authorize?scope=read:user%20public_repo&client_id=${GH_CLIENT_ID}&redirect_uri=${NEXTAUTH_URL}/api/auth/github-vinculation`

  if (username && token) {
    return (
      <>
        <div className="vinculated-container">
          <a
            href={`https://github.com/${username}`}
            target="_blank"
            rel="noopener noreferrer"
            className="vinculated"
          >
            <div className="icon-vinculated github">
              <FaGithub size="30px" color="white" />
            </div>
            <div className="vinculated-username">
              {username}
            </div>
          </a>
          <TransparentButton onClick={() => setRemove(true)}>
            <MdClose />
          </TransparentButton>
        </div>
        <ConfirmationModal
          title="¿Deseas desvincular tu cuenta de GitHub?"
          description="Esta cuenta ya no estará asociada a tu perfil ni a tus proyectos."
          onConfirm={() => mutate()}
          onCancel={() => setRemove(false)}
          cta="Desvincular"
          visible={remove}
        />
        {isError ? (
          <Notification
            title="Desvinculacion fallida"
            message="Ha ocurrido un problema al intentar eliminar tu cuenta de github."
            report
            error
          />
        ) : null}
      </>
    )
  }
  return (
    <SocialMediaVinculationStyled className="social-media-vinculation" color="var(--neutral90)">
      <div className="icon-container">
        <FaGithub size="48px" color="white" />
      </div>
      <div className="vinculation-copy">
        <Typography font="headline6" as="h3">
          Vincula tu cuenta de GitHub
        </Typography>
        <Typography font="regular">
          Al vincular tu cuenta de GitHub podrás conectar tu repositorio con el proyecto que te encuentres desarrollando.
        </Typography>
      </div>
      <a href={(username && token) ? `https://github.com/${username}` : url} target={username ? '_blank' : '_self'} rel="noopener noreferrer">
        <SecondaryButton height="48" fitContent fullWidth fontWeight="500">
          Vincular Github
        </SecondaryButton>
      </a>
      {isSuccess ? (
        <Notification
          title="Desvinculacion exitosa"
          message="Hemos eliminado tu cuenta de github, recuerda que es necesaria una para poder mandar a revisión tus proyectos"
        />
      ) : null}
    </SocialMediaVinculationStyled>
  )
}

export default GitHubButton
